/* tslint:disable */

/**
 */
export class TempRecordPtsDefSave {
    axis2PL13?: number;
    axis1TopSurf?: number;
    axis3TopSurf?: number;
    axis1IntPt?: number;
    axis2IntPt?: number;
    axis3IntPt?: number;
    axis1BotSurf?: number;
    axis2BotSurf?: number;
    axis3BotSurf?: number;
    axis2TopSurf?: number;
    axis3PL12?: number;
    axis1PL23?: number;
    axis2Axe1?: number;
    axis3Axe1?: number;
    axis1Axe2?: number;
    axis3Axe2?: number;
    axis1Axe3?: number;
    axis2Axe3?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/temp-record-pts-def-save.ts